// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"417":"78e4097c","753":"f3af6d60"}[chunkId] + ".chunk.css";
};